<template>
    <div class="poster-last">
        <div class="content-box">
            <div class="content">
            <template v-if="info.total>0">
                <div class="title-box">
                    <img class="left-iocn" src="../../assets/img/poster-img/poster-last-left-con.png" alt="">
                    <div class="title-text">初步评估你的企业可以获得政策补贴</div>
                    <div class="money-box">
                        <div class="money-content">
                            <span>{{info.maxSubsidy}}亿</span>
                        </div>
                    </div>
                    <p class="title-total">匹配到的补贴政策共计<span>{{info.total}}条</span></p>
                    <img class="right-iocn" src="../../assets/img/poster-img/poster-last-right-con.png" alt="">
                </div>
                <div class="title-line"></div>
                <div :class="['list-box',companyInfo.isFilled===1 ? 'list-box-height' : '']" @click="isShowCode=true">
                    <template v-if="info.policyTitleList && info.policyTitleList.length>0">
                    <div class="list" v-for="item in info.policyTitleList" :key="item">
                        <span></span>
                        <p class="p-ellipsis-2">{{item}}</p>
                    </div>
                    </template>
                </div>
            </template>
            <div class="space-text" v-else>
                <img src="@/assets/img/poster-img/poster-quesheng.png" alt="">
                <p>暂无数据哦~</p></div>
            <div v-if="(companyInfo!=='null' && companyInfo.isFilled===0) || companyInfoArr.length===0" class="improve-info"  @click="isShowImproveInfo=true">
                完善信息，查看更多政策
            </div>
            <div class="content-bottom">
                <img :class="['code',isWeixin ? 'wechat-margin' : '']" src="@/assets/img/poster-img/qrcode.png" alt="">
                <div v-if="isWeixin" class="bottom-right">
                    <img src="@/assets/img/poster-img/poster-last-zhiwen.png" alt="">
                    <div class="bottom-text">长按二维码关注公众号</div>
                    <div class="bottom-text-last">查看全部惠企政策</div>
                </div>
                <div v-else class="bottom-right no-wechat">
                    <p><span>2</span>步关注公众号</p>
                    <img src="@/assets/img/poster-img/poster-last-wechat.png" alt="">
                    <div class="brief">1、长按保存二维码在相册中</div>
                    <div class="brief">2、在微信中识别进行关注</div>
                </div>
            </div>
        </div>
        </div>
        <div class="footer">
            <div class="btn" @click="shareHandle">推荐给好友测测</div>
            <div class="text"><img src="@/assets/img/poster-img/poster-last-war.png">本测评结果根据用户所填信息计算所得，结果仅供参考</div>
        </div>
        <van-popup
        v-model="isShowCode"
        closeable
        round
        position="bottom"
        :style="{ height: '60%' }"
        >
        <div v-if="isWeixin" class="popup-title">
            <div class="popup-title-bg">
                使用政策补贴宝 不再错失<span>万亿</span>政策补贴
            </div>
        </div>
        <div v-else class="popup-title">
            <div class="popup-title-bg">
                <span>2</span>步关注公众号查看全部惠企政策
            </div>
        </div>
        <img class="popup-code" src="@/assets/img/poster-img/qrcode.png" alt="">
        <p v-if="isWeixin" class="popup-text">长按二维码关注公众号查看全部惠企政策</p>
        <template v-else>
            <p class="popup-text">1、长按保存二维码在相册中</p>
            <p class="popup-text">2、在微信中识别进行关注</p>
        </template>
        </van-popup>
        <van-popup
        v-model="isShowImproveInfo"
        closeable
        round
        position="bottom"
        :style="{ height: '70%' }"
        >
        <div class="popup-box">
            <div class="popup-header-title">完善信息</div>
            <div class="popup-company" @click="popupCompanyInfoHandle">
                <span :class="['company-name',!companyName ? 'placeholder-style' : '']">{{companyName ? companyName :'请输入企业名称'}}</span>
                    <span v-if="companyName && !companyInfo.companyName" @click.stop="clearHandle" class="iconfont clear-style">&#xe6a0;</span>
            </div>
            <div class="label" @click="isShowPopup=true">
                <div class="lable-left">企业人员规模</div>
                <div class="lable-right">
                    <span v-if="!companyNum" class="placeholder">请填写</span>
                    <span v-else>{{companyNum}} {{companyNum ? '人': ''}}</span>
                    <span class="iconfont right-icon">&#xe6aa;</span>
                </div>
            </div>
            <div class="label" @click="isShowLoan=true">
            <div class="lable-left">{{companyInfo.lastYear}}年营业收入</div>
            <div class="lable-right">
                <span v-if="!loanPlan" class="placeholder">请选择</span>
                <span v-else>{{loanPlan}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span></div>
        </div>
        <div class="submitInfo" @click="submitHandle">立即匹配</div>
        </div>
        </van-popup>
        <!-- 输入企业信息弹层 -->
        <van-popup
            v-model="isShowPopupCompanyName"
            closeable
            round
            close-icon-position="top-left"
            position="bottom"
            :style="{ height: '95%' }"
        >
            <div class="popup-enterprisename">
                <div class="title">
                    企业名称
                    <div class="define" @click="selectCompany(inputEnterpriseName)">确定</div>
                </div>
                <div class="inputbox">
                    <input
                        ref="enterpriseName"
                        v-model="inputEnterpriseName"
                        maxlength="150"
                        placeholder="请输入企业名称"
                    />
                    <span v-show="inputEnterpriseName != ''" class="iconfont iconxingzhuang8" @click="clearInputEnterpriseName"></span>
                </div>
                <div class="companylistbox">
                    <div v-if="loading" class="loadingbox"><van-loading /></div>
                    <ul v-if="!loading && companyList.length > 0" class="companylist">
                        <li v-for="(item, index) in companyList" :key="index" @click="selectCompany(item.companyName)" v-html="item.companyName"></li>
                    </ul>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="isShowPopup" round position="bottom" :style="{ height: '50%' }" :closeable="true" :afe-area-inset-bottom="true">
            <div class="label-name">企业人员规模</div>
            <van-field
            v-model="dataValue"
            rows="2"
            autosize
            label=""
            type="digit"
            maxlength="7"
            placeholder="请输入"
            >
            <template #button>
                <van-button size="small" type="default">人</van-button>
            </template>
            </van-field>
            <div class="save-btn" @click="saveDataHandle">保存</div>
        </van-popup>
        <van-popup v-model="isShowLoan" round position="bottom" :style="{ height: '40%' }" :afe-area-inset-bottom="true">
        <van-picker
            :title="`${companyInfo.lastYear}年的营业收入`"
            show-toolbar
            value-key="val"
            :columns="columns"
            @confirm="loanHandle"
            @cancel="isShowLoan=false"
            />
        </van-popup>
        <van-overlay :show="isShowMask" @click="show = false">
            <img  class="mask-img" src="@/assets/img/poster-img/share-icon.png" alt="">
            <div class="mask-button" @click="isShowMask=false">我知道了</div>
        </van-overlay>
    </div>
</template>
<script>
import { companyMaterial,registerDoIdem } from "@/api/api_poster.js"
import { debounce } from '@/utils/util'
import { companySearch,cardShareInfo} from '@/api/api_home'
import {version} from '@/utils/util.js'
export default {
    data(){
        return {
            info:{},
            companyInfo:{},
            companyInfoArr:[],
            isWeixin:null,
            isShowCode:false,
            isShowImproveInfo:false,
            companyName:"",
            isShowPopup:false,
            companyNum:'',
            dataValue:'',
            isShowLoan:false,
            columns: [{id:2000000000,val:'Y≥2亿元'}, {id:20000,val:'5000万元≤Y<2亿元'},{id:5000,val:'500万元≤Y<5000万元'},{id:500,val:'Y<500万元'}],
            loanPlan:"",
            isShowPopupCompanyName: false, // 输企业名称弹层
            inputEnterpriseName:"",
            loading:false,
            companyList:[],
            totalRevenue:"",
            isShowMask:false,
        }
    },
    watch: {
		inputEnterpriseName: function(){
			this.onSearch();
		}
	},
    mounted(){
        let {info}=this.$route.query
        this.info=JSON.parse(info)
        this.getCompanyInfo()
        this.isWeixin=version().weixin
    },
    methods:{
        shareHandle(){
            if(this.isWeixin){
                this.isShowMask=true
                this.defalutShare()
            }else{
                this.$router.push({
                    path:'/specialpostershare'
                })
            }
        },
            async defalutShare() {
            let params = {
            type: 1
            }
            let res = await cardShareInfo(params)
            if(res && res.ok){
            let data = res.data
                this.WechatShare({
                title: data.title,
                desc: data.desc,
                imgUrl: data.imgUrl,
                link: data.linkUrl
                })
            }
        },
        popupCompanyInfoHandle(){
            if(!this.companyInfo.companyName){
                this.isShowPopupCompanyName=true
            }
        },
        submitHandle(){
            if(!this.companyName){
                this.$toast('请填写企业名称')
                return false
            }
            let params={
                companyName:this.companyName,
                employeeNum:parseInt(this.companyNum),
                totalRevenue:this.totalRevenue
            }
            registerDoIdem(params).then(res=>{
                if(res.ok===true){
                    this.$toast('保存成功')
                    this.isShowImproveInfo=false
                    this.getCompanyInfo()
                }
            }) 
        },
        selectCompany (item) {
			this.companyName = item.replace('<span style="color:#398DFF">','').replace('</span>','')
			this.isShowPopupCompanyName = false
		},
		clearInputEnterpriseName() {
			this.inputEnterpriseName = ''
			this.companyList = []
		},
		onSearch() {
			debounce(this.getCompanyList, 1000)()
		},
		getCompanyList(){
			this.loading = true
			let params = {
				companyName: this.inputEnterpriseName
			}
			companySearch(params).then((res)=>{
				this.loading = false
				if(res && res.ok){
					this.companyList = res.data
					this.companyList.forEach((e) => {
						e.companyName = e.companyName.replace(''+this.inputEnterpriseName,'<span style="color:#398DFF">'+this.inputEnterpriseName+'</span>')
					})
				}
			})
		},
        loanHandle(value){
            this.loanPlan=value.val
            this.isShowLoan=false
            this.totalRevenue=value.id
        },
        saveDataHandle(){
                if(parseInt(this.dataValue)===0){
                this.$toast('企业规模人员不能为0哦~')
                return false
                }else if(parseInt(this.dataValue)<0){
                    this.$toast('企业规模人员不能为负数哦~')
                return false
                }
                this.companyNum=this.dataValue
            this.isShowPopup=false
        },
        clearHandle(){
            this.companyName=""
        },
        getCompanyInfo(){
            companyMaterial().then(res=>{
                if(res.ok===true){
                    let {data}=res
                    if(data){
                        this.companyInfo=data
                    this.companyName=data.companyName
                    }
                    this.companyInfoArr=Object.keys(this.companyInfo)
                    
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.poster-last{
    background: url('../../assets/img/poster-img/poster-last-bg.png') center center no-repeat;
    background-size: cover;
    min-height: 100vh;
    padding-top: 30px;
    position: relative;
    display: flex;
    flex-direction: column;
}
.content-box{
    flex: 1;
}
.content{
    background: url('../../assets/img/poster-img/poster-last-content-bg-block.png');
    width: 303px;
    height: 464px;
    margin: 0 auto 0;
    background-size: cover;
    position: relative;
    .title-box{
        position: relative;
        margin-bottom: 36px;
        img{
            width:16px;
            height: 16px;
            display: blocks;
        }
        .left-iocn{
            position: absolute;
            left: 15px;
            top:15px;
        }
        .right-iocn{
            position: absolute;
            right: 15px;
            top:121px;
        }
        .title-text{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:20px;
            text-align: center;
            padding-top: 30px;
        }
        .money-box{
            height: 39px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin:  9px auto 0;
            font-size:30px;
            font-family:DINAlternate-Bold,DINAlternate;
            font-weight:bold;
            color:rgba(57,140,253,1);
            line-height:35px;
            .money-content{
                background: url('../../assets/img/poster-img/money-bg.png');
                background-size: cover;
                span{
                    display: block;
                    padding:0 16px;
                }
            }
            }
            .title-total{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:20px;
            text-align: center;
            padding-top: 8px;
            span{
            font-family:DINAlternate-Bold,DINAlternate;
            font-weight:bold;
            color:rgba(57,140,253,1);
            line-height:16px;

            }
        }
        }
        .list-box{
            height: 96px;
            overflow: scroll;
            margin: 0 15px 0;
            margin-top:11px;
            .list{
                display: flex;
                align-items: baseline;
                margin-bottom: 10px;
                span{
                    width:8px;
                    height:8px;
                    background:rgba(57,140,253,1);
                    display: inline-block;
                    flex-shrink: 0;
                    margin-right: 8px;
                }
                p{
                    font-size:13px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:18px;
                    max-width:232px;
                }
            }
        }
        .list-box-height{
            height: 122px;
            margin-top: 20px;
        }
        .title-line{
            width:100%;
            height:1px;
            background:rgba(57,140,253,1);
            opacity:0.2018;
        }
        .space-text{
                text-align: center;
                padding-top: 100px;
                img{
                    width:93px;
                    height: 81px;
                    display: block;
                    margin:0 auto 0;
                }
                p{
                    font-size:13px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:18px;
                    padding-top:20px;
                    text-align: center;
                }
            }
        .improve-info{
            width:193px;
            height:32px;
            border-radius:18px;
            border:1px solid rgba(57,140,253,1);
            font-size:13px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(57,140,253,1);
            line-height:32px;
            text-align: center;
            margin:10px auto 10px;
        }
        .content-bottom{
            display: flex;
            justify-content: space-between;
            padding: 0px 15px 0;
            position: absolute;
            bottom: 19px;
            .code{
                width:103px;
                height: 103px;
                background: #ddd;
                display: block;
                margin-right: 10px;
            }
            .wechat-margin{
                margin-right:28px;
            }
            .bottom-right{
            img{
                width:35px;
                height: 36px;
                display: block;
                margin: 11px 0 15px;
            }
            .bottom-text{
                font-size:13px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:18px;
            }
            .bottom-text-last{
                color: #FA9D3B;
                font-size:13px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                line-height:18px;
            } 
            }
            .no-wechat{
                p{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:17px;
                    padding-bottom: 5px;
                    span{
                        height:19px;
                        font-size:16px;
                        font-family:DIN-Black,DIN;
                        font-weight:900;
                        color:rgba(250,157,59,1);
                        line-height:19px;
                        display: inline-block;
                        margin:0 4px;
                    }
                }
                img{
                    width:127px;
                    height: 21px;
                    display: block;
                    
                }
                .brief{
                    margin-top: 5px;
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:17px;
                }
            }
        }
}
.footer{
            padding:10px 15px 25px;
            .text{
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 5px;
                img{
                    width:13px;
                    height: 13px;
                    display: inline-block;
                    margin-right: 3px;
                }
                font-size:13px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:18px;
            }
            .btn{
                width:343px;
                height:40px;
                background:rgba(255,255,255,1);
                border-radius:20px;
                text-align: center;
                font-size:16px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(57,140,253,1);
                line-height:40px;
                margin-top:5px;
            }
        }
        .popup-title{
            height:36px;
            border-radius:2px;
            font-size:16px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(57,140,253,1);
            line-height:36px;
            text-align: center;
            margin: 40px auto 0;
            display: flex;
            justify-content: center;
            .popup-title-bg{
                background:rgba(78,153,254,0.18);
                padding: 0 10px;
                span{
                color: #FA9E3D;
                }
            }
            
        }
        .popup-code{
            width:149px;
            height:149px;
            display: block;
            margin:20px auto 21px;
        }
        .popup-text{
            font-size:16px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:30px;
            text-align: center;
        }
        .popup-box{
            padding: 0 20px;
            .popup-header-title{
                font-size:16px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:18px;
                margin-top:20px;
            }
        .popup-company{
            border-bottom:1px solid #eee;
            padding-top: 39px;
            text-align: left;
            display: flex;
            align-items: center;
            padding-bottom: 18px;
            .company-name{
                display: inline-block;
                width:100%;
            }
            .placeholder-style{
                font-size:16px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(204,204,204,1);
                line-height:14px;
            }
            /deep/ .van-cell{
                padding: 10px 0 19px 0;
            }
            /deep/ .van-cell::after{
                border:0
            }
            /deep/ .van-field__control{
                font-size:16px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                line-height:16px;
            }
            .clear-style{
                color: #ddd;
            }
            }
            .submitInfo{
                width:315px;
                height:44px;
                background:rgba(57,141,255,1);
                box-shadow:0px 5px 10px 0px rgba(57,141,255,0.3);
                border-radius:22px;
                margin:88px auto 0;
                font-size:16px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:44px;
                text-align: center;
            }
        }
        .label{
            height: 50px;
            border-bottom: 1px solid #EEEEEE;
            display: flex;
            justify-content: space-between;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:@darkBlack;
            line-height:50px;
            .lable-left {
                .required-star{
                    color: #FA5151;
                    margin: 0;
                    padding: 0;
                    display: inline-block;
                    font-size: inherit;
                }
            }
            .lable-right{
                display: flex;
                align-items: center;
                .category-text{
                    display: inline-block;
                    max-width: 232px;
                }
                .placeholder{
                    color: @lightBlack;
                }
                .right-icon{
                font-size: 15px;
                color: @lightBlack;
                margin: 0 0 0 20px;
                display: inline-block;
            }
            }
        }
        .label-name{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
padding: 20px 0 37px 20px;
}
/deep/ .van-button--default{
    border:0;
}
.save-btn{
    text-align: center;
    width:335px;
    height:40px;
    background:rgba(57,141,255,1);
    border-radius:5px;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
    margin: 80px auto 0;
}
.popup-enterprisename {
				padding: 16px 20px;
				.title {
					text-align: center;
					font-size: 18px;
					line-height: 22px;
					position: relative;
					margin-bottom: 22px;
					.define{
						position: absolute;
						top: 0;
						right: 0;
						font-size: 14px;
						line-height: 22px;
					}
				}
				.inputbox{
					position: relative;
					padding-right: 20px;
					line-height: 26px;
					height: 58px;
                    margin-bottom: 0;
                    border-bottom: 1px solid #eee;
                    display: flex;
					input {
						width: 100%; 
						font-size: 20px;
						border: none;
					}
					.iconfont {
						font-size: 14px;
						position: absolute;
						right: 0;
                        top: 18px;
                        color: #ddd;
					}
				}
				.companylistbox {
					.loadingbox {
						padding-top: 100px;
						text-align: center;
					}
					ul.companylist {
						height: 400px;
						overflow-y: scroll;
						li {
							font-size: 14px;
							line-height: 20px;
							padding: 15px 0;
							border-bottom: 1px solid #dddddd;
							font-size: 14px;
							color: #333333;
						}
					}
				}
            }
                .mask-img{
                    width:281px;
                    height: 101px;
                    display: block;
                    position: absolute;
                    top:5px;
                    right: 3px;
                }
                .mask-button{
                    width:112px;
                    height:38px;
                    border-radius:20px;
                    border:1px solid rgba(255,255,255,1);
                    font-size:16px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:38px;
                    text-align: center;
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin:auto;
                    top:206px;
                }
</style>